// extracted by mini-css-extract-plugin
module.exports = {"container":"_8d2bdfc6","heading":"_a887a763"};